
<div class="head-info" :class="center && 'center'">
  <span>{{ title }}</span>
  <p><a>{{ content }}</a></p>
</div>
